import portraitImg from '../../../image/2.png';
import './AboutUsSection.css';

const AboutUsSection = () => {
  return (
    <section className="about-us section section--lg" aria-labelledby="about-us-heading">
      <div className="container">
        <div className="about-us__layout">
          <div className="about-us__copy">
            <p className="about-us__eyebrow">Sobre Nosotros</p>
            <h2 id="about-us-heading" className="about-us__title">
              <span className="about-us__title-accent">Always Aligners</span>
            </h2>
            <p className="about-us__subtitle">
              Un sistema clínico para el tratamiento con alineadores
            </p>
            <div className="about-us__body">
              <p>
                Always Aligners es un sistema desarrollado por la Dra. Patricia Tarquini y su equipo
                clínico, que integra diagnóstico, planificación digital, biomecánica y fabricación de
                alineadores para el tratamiento ortodóncico.
              </p>
              <p>
                Nuestro enfoque surge de la práctica clínica diaria y de la necesidad de contar con
                herramientas que permitan a los profesionales trabajar con alineadores de forma
                predecible, comprendiendo no solo la tecnología, sino también los fundamentos
                biomecánicos que sustentan cada movimiento dentario.
              </p>
              <p>
                Always Aligners combina experiencia clínica, tecnología digital y formación
                profesional, ofreciendo a los odontólogos un sistema de trabajo que les permita
                integrar los alineadores dentro de su práctica con mayor seguridad y criterio
                terapéutico.
              </p>
            </div>
          </div>

          <aside className="about-us__visual">
            <figure className="about-us__figure">
              <img
                src={portraitImg}
                alt="Dra. Patricia Tarquini, sistema Always Aligners"
                className="about-us__image"
                loading="lazy"
                decoding="async"
              />
            </figure>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
